(ns ui.cofx.util
  (:require
   [re-frame.core :as rf]
   [frontend.db :as app-db]
   [frontend.state.current-session :as session]))

(def tenant-schema-cofx ::tenant-schema-cofx)

(defn tenant-schema
  [cofx _]
  (assoc cofx :tenant-schema @session/tenant-schema))

(rf/reg-cofx
 tenant-schema-cofx
 tenant-schema)

(def default-currency-cofx ::default-currency-cofx)

(defn default-currency
  [cofx _]
  (assoc cofx :default-currency @session/default-currency))

(rf/reg-cofx
 default-currency-cofx
 default-currency)

(def tenant-cofx ::tenant-cofx)

(defn tenant
  [cofx _]
  (assoc cofx :tenant @session/tenant))

(rf/reg-cofx
 tenant-cofx
 tenant)

(def current-account-cofx ::current-account-cofx)

(defn current-account
  [cofx _]
  (assoc cofx :current-account @session/account))

(rf/reg-cofx
 current-account-cofx
 current-account)

(def active-user-account-roles-cofx ::active-user-account-roles-cofx)

(defn active-user-account-roles
  [cofx _]
  (assoc cofx :active-user-account-roles @app-db/active-user-account-roles))

(rf/reg-cofx
 active-user-account-roles-cofx
 active-user-account-roles)

(def now-cofx ::now-cofx)

(defn now
  [cofx _]
  (assoc cofx :now (.getTime (js/Date.))))

(rf/reg-cofx
 now-cofx
 now)
